// This file is auto-generated by backstage-cli translations import
// Do not edit manually.

import { createTranslationResource } from '@backstage/frontend-plugin-api';
import { apiDocsTranslationRef } from '@backstage/plugin-api-docs/alpha';
import { catalogTranslationRef } from '@backstage/plugin-catalog/alpha';
import { catalogGraphTranslationRef } from '@backstage/plugin-catalog-graph/alpha';
import { catalogImportTranslationRef } from '@backstage/plugin-catalog-import/alpha';
import { catalogReactTranslationRef } from '@backstage/plugin-catalog-react/alpha';
import { coreComponentsTranslationRef } from '@backstage/core-components/alpha';
import { homeTranslationRef } from '@backstage/plugin-home/alpha';
import { homeReactTranslationRef } from '@backstage/plugin-home-react/alpha';
import { orgTranslationRef } from '@backstage/plugin-org/alpha';
import { notificationsTranslationRef } from '@backstage/plugin-notifications/alpha';
import { scaffolderTranslationRef } from '@backstage/plugin-scaffolder/alpha';
import { scaffolderReactTranslationRef } from '@backstage/plugin-scaffolder-react/alpha';
import { searchTranslationRef } from '@backstage/plugin-search/alpha';
import { searchReactTranslationRef } from '@backstage/plugin-search-react/alpha';
import { techdocsTranslationRef } from '@backstage/plugin-techdocs/alpha';
import { userSettingsTranslationRef } from '@backstage/plugin-user-settings/alpha';

export default [
  createTranslationResource({
    ref: apiDocsTranslationRef,
    translations: {
    "es": () => import('./../../translations/messages/api-docs.es.json'),
    },
  }),
  createTranslationResource({
    ref: catalogTranslationRef,
    translations: {
    "es": () => import('./../../translations/messages/catalog.es.json'),
    },
  }),
  createTranslationResource({
    ref: catalogGraphTranslationRef,
    translations: {
    "es": () => import('./../../translations/messages/catalog-graph.es.json'),
    },
  }),
  createTranslationResource({
    ref: catalogImportTranslationRef,
    translations: {
    "es": () => import('./../../translations/messages/catalog-import.es.json'),
    },
  }),
  createTranslationResource({
    ref: catalogReactTranslationRef,
    translations: {
    "es": () => import('./../../translations/messages/catalog-react.es.json'),
    },
  }),
  createTranslationResource({
    ref: coreComponentsTranslationRef,
    translations: {
    "es": () => import('./../../translations/messages/core-components.es.json'),
    },
  }),
  createTranslationResource({
    ref: homeTranslationRef,
    translations: {
    "es": () => import('./../../translations/messages/home.es.json'),
    },
  }),
  createTranslationResource({
    ref: homeReactTranslationRef,
    translations: {
    "es": () => import('./../../translations/messages/home-react.es.json'),
    },
  }),
  createTranslationResource({
    ref: orgTranslationRef,
    translations: {
    "es": () => import('./../../translations/messages/org.es.json'),
    },
  }),
  createTranslationResource({
    ref: notificationsTranslationRef,
    translations: {
    "es": () => import('./../../translations/messages/plugin.notifications.es.json'),
    },
  }),
  createTranslationResource({
    ref: scaffolderTranslationRef,
    translations: {
    "es": () => import('./../../translations/messages/scaffolder.es.json'),
    },
  }),
  createTranslationResource({
    ref: scaffolderReactTranslationRef,
    translations: {
    "es": () => import('./../../translations/messages/scaffolder-react.es.json'),
    },
  }),
  createTranslationResource({
    ref: searchTranslationRef,
    translations: {
    "es": () => import('./../../translations/messages/search.es.json'),
    },
  }),
  createTranslationResource({
    ref: searchReactTranslationRef,
    translations: {
    "es": () => import('./../../translations/messages/search-react.es.json'),
    },
  }),
  createTranslationResource({
    ref: techdocsTranslationRef,
    translations: {
    "es": () => import('./../../translations/messages/techdocs.es.json'),
    },
  }),
  createTranslationResource({
    ref: userSettingsTranslationRef,
    translations: {
    "es": () => import('./../../translations/messages/user-settings.es.json'),
    },
  }),
];
// This file is auto-generated by backstage-cli translations import
// Do not edit manually.

import { createTranslationResource } from '@backstage/frontend-plugin-api';
import { apiDocsTranslationRef } from '@backstage/plugin-api-docs/alpha';
import { catalogTranslationRef } from '@backstage/plugin-catalog/alpha';
import { catalogGraphTranslationRef } from '@backstage/plugin-catalog-graph/alpha';
import { catalogImportTranslationRef } from '@backstage/plugin-catalog-import/alpha';
import { catalogReactTranslationRef } from '@backstage/plugin-catalog-react/alpha';
import { coreComponentsTranslationRef } from '@backstage/core-components/alpha';
import { homeTranslationRef } from '@backstage/plugin-home/alpha';
import { homeReactTranslationRef } from '@backstage/plugin-home-react/alpha';
import { orgTranslationRef } from '@backstage/plugin-org/alpha';
import { notificationsTranslationRef } from '@backstage/plugin-notifications/alpha';
import { scaffolderTranslationRef } from '@backstage/plugin-scaffolder/alpha';
import { scaffolderReactTranslationRef } from '@backstage/plugin-scaffolder-react/alpha';
import { searchTranslationRef } from '@backstage/plugin-search/alpha';
import { searchReactTranslationRef } from '@backstage/plugin-search-react/alpha';
import { techdocsTranslationRef } from '@backstage/plugin-techdocs/alpha';
import { userSettingsTranslationRef } from '@backstage/plugin-user-settings/alpha';

export default [
  createTranslationResource({
    ref: apiDocsTranslationRef,
    translations: {
    "es": () => import('./../../translations/messages/api-docs.es.json'),
    },
  }),
  createTranslationResource({
    ref: catalogTranslationRef,
    translations: {
    "es": () => import('./../../translations/messages/catalog.es.json'),
    },
  }),
  createTranslationResource({
    ref: catalogGraphTranslationRef,
    translations: {
    "es": () => import('./../../translations/messages/catalog-graph.es.json'),
    },
  }),
  createTranslationResource({
    ref: catalogImportTranslationRef,
    translations: {
    "es": () => import('./../../translations/messages/catalog-import.es.json'),
    },
  }),
  createTranslationResource({
    ref: catalogReactTranslationRef,
    translations: {
    "es": () => import('./../../translations/messages/catalog-react.es.json'),
    },
  }),
  createTranslationResource({
    ref: coreComponentsTranslationRef,
    translations: {
    "es": () => import('./../../translations/messages/core-components.es.json'),
    },
  }),
  createTranslationResource({
    ref: homeTranslationRef,
    translations: {
    "es": () => import('./../../translations/messages/home.es.json'),
    },
  }),
  createTranslationResource({
    ref: homeReactTranslationRef,
    translations: {
    "es": () => import('./../../translations/messages/home-react.es.json'),
    },
  }),
  createTranslationResource({
    ref: orgTranslationRef,
    translations: {
    "es": () => import('./../../translations/messages/org.es.json'),
    },
  }),
  createTranslationResource({
    ref: notificationsTranslationRef,
    translations: {
    "es": () => import('./../../translations/messages/plugin.notifications.es.json'),
    },
  }),
  createTranslationResource({
    ref: scaffolderTranslationRef,
    translations: {
    "es": () => import('./../../translations/messages/scaffolder.es.json'),
    },
  }),
  createTranslationResource({
    ref: scaffolderReactTranslationRef,
    translations: {
    "es": () => import('./../../translations/messages/scaffolder-react.es.json'),
    },
  }),
  createTranslationResource({
    ref: searchTranslationRef,
    translations: {
    "es": () => import('./../../translations/messages/search.es.json'),
    },
  }),
  createTranslationResource({
    ref: searchReactTranslationRef,
    translations: {
    "es": () => import('./../../translations/messages/search-react.es.json'),
    },
  }),
  createTranslationResource({
    ref: techdocsTranslationRef,
    translations: {
    "es": () => import('./../../translations/messages/techdocs.es.json'),
    },
  }),
  createTranslationResource({
    ref: userSettingsTranslationRef,
    translations: {
    "es": () => import('./../../translations/messages/user-settings.es.json'),
    },
  }),
];
